import React, { useState } from 'react';
import { Box, Button, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import ContentCut from '@mui/icons-material/ContentCut';
import { Icon } from '@iconify/react';
import DialogFormAction from './DialogFormAction';
import useWalletEvents from '../../../../hooks/useWalletEvents';
import { firestore } from '../../../../contexts/FirebaseContext';
import useAuthUsers from '../../../../hooks/useAuthUsers';

function MenuOptions({ dataItem }) {
  const { userToPay, status, servicio, montoPagado, category_service_id, referenceCode, history } = dataItem;
  const [anchorEl, setAnchorEl] = useState(null);
  const { handleWalletEvent } = useWalletEvents();
  const { currentUser } = useAuthUsers();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // eslint-disable-next-line consistent-return
  const handleReembolso = async (dataForm, evento) => {
    if (evento === 'ACCEPT') {
      // console.log('accept');
      const obj = {
        nameEvent: 'ADD',
        ownerUserID: userToPay,
        category_service_id: category_service_id || 'PAQUETERIA',
        amount: montoPagado,
        message: dataForm.message,
        reason: 'Reembolso - CLIP',
        payment_method: 'ABONO',
        payment_source: 'DAGPACKET',
        rerport_id: '',
        successFuncts: [],
        successSnackbar: true
      };

      await handleWalletEvent(obj);

      const res = firestore
        .collection('clip_reembolso')
        .doc(dataItem.id)
        .update({
          status: 'ACEPTADO',
          updated_at: new Date(),
          history: [
            ...history,
            {
              status: 'ACEPTADO',
              date: new Date(),
              reason: dataForm.message,
              actionUser: currentUser.id
            }
          ]
        });

      return res;
    }
    if (evento === 'REJECT') {
      // console.log('reject');
      const res = firestore
        .collection('clip_reembolso')
        .doc(dataItem.id)
        .update({
          status: 'RECHAZADO',
          updated_at: new Date(),
          history: [
            ...history,
            {
              status: 'RECHAZADO',
              date: new Date(),
              reason: dataForm.message,
              actionUser: currentUser.id
            }
          ]
        });

      return res;
    }
  };

  return (
    <>
      {/* <Typography>SimpleMenu</Typography> */}
      <>
        {/* <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          Dashboard
        </Button> */}
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <Icon icon="mingcute:more-2-fill" />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button'
          }}
        >
          <DialogFormAction handleReembolso={handleReembolso} text="Aceptar reembolso" evento="ACCEPT" />
          <DialogFormAction handleReembolso={handleReembolso} text="Rechazar reembolso" evento="REJECT" />

          {/* <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <ContentCut fontSize="small" />
            </ListItemIcon>
            <ListItemText>Texto para ver</ListItemText>
          </MenuItem>

          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <ContentCut fontSize="small" />
            </ListItemIcon>
            <ListItemText>Texto para ver</ListItemText>
            <Typography variant="body2" color="text.secondary">
              ⌘X
            </Typography>
          </MenuItem>

          <MenuItem onClick={handleClose}>Logout</MenuItem> */}
        </Menu>
      </>
    </>
  );
}

export default MenuOptions;
